class SelectOption {
  constructor(value, label) {
    this.value = value;
    this.label = label;
  }
}

export function createSelectOption(value, label) {
  return new SelectOption(value, label);
}



// WEBPACK FOOTER //
// ./src/app/shared/select/select.option.js